import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import { router } from './router';
import { auth } from '../firebase';
//import store from './store'
import store from './storeV2'
//sentry 
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";

//detect mobile
import VueMobileDetection from 'vue-mobile-detection';
import VueMask from 'v-mask'

Vue.use(VueMobileDetection);
Vue.use(VueMask);

let app;

auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app');

    Sentry.init({
      dsn: "https://e0f0cc949ad74169a516560deeb015c7@o473172.ingest.sentry.io/5507849",
      integrations: [
        new VueIntegration({
          app,
          tracing: true,
        }),
        new Integrations.BrowserTracing(),
      ],

      // We recommend adjusting this value in production, or using tracesSampler
      // for finer control
      tracesSampleRate: 1.0,
    });
  }
});




